import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
    }
  }

  showTyping(event) {
    const container = document.getElementById("messages-container")
    if (container && container.parentElement) {
      setTimeout(() => {
        container.parentElement.scrollTop = container.parentElement.scrollHeight
      }, 100)
    }

    const aiStatus = document.getElementById("ai-status")
    if (aiStatus) {
      aiStatus.textContent = "Thinking..."
      aiStatus.classList.add("text-yellow-400")
    }

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.textContent = "Sending..."
    }

    if (this.hasInputTarget) {
      this.inputTarget.value = ""
    }
  }

  hideTyping(event) {
    const aiStatus = document.getElementById("ai-status")
    if (aiStatus) {
      aiStatus.textContent = "Ready to help"
      aiStatus.classList.remove("text-yellow-400")
    }

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
      this.submitTarget.textContent = "Send"
    }

    if (this.hasInputTarget) {
      this.inputTarget.focus()
    }
  }

  reset(event) {
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
      this.inputTarget.style.height = "auto"
      this.inputTarget.focus()
    }

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
      this.submitTarget.textContent = "Send"
    }
  }

  handleEnter(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.element.requestSubmit()
    }
  }

  adjustHeight(event) {
    const input = event.target
    input.style.height = "auto"
    input.style.height = Math.min(input.scrollHeight, 200) + "px"
  }
}
